"use client"

import * as React from "react"
import { ChevronUpIcon } from "lucide-react"
import { AnimatePresence, motion } from "motion/react"

import { useMounted } from "@/hooks/use-mounted"

export function ScrollToTop() {
  const [isVisible, setIsVisible] = React.useState(false)
  const isMounted = useMounted()

  React.useEffect(() => {
    if (!isMounted) return

    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true)
      } else {
        setIsVisible(false)
      }
    }

    window.addEventListener("scroll", toggleVisibility)
    return () => window.removeEventListener("scroll", toggleVisibility)
  }, [isMounted])

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  }

  if (!isMounted) {
    return null
  }

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.button
          initial={{ opacity: 0, scale: 0, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0, y: 20 }}
          whileTap={{ scale: 0.95 }}
          onClick={scrollToTop}
          className="bg-primary text-primary-foreground fixed right-6 bottom-6 z-50 flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border transition-colors sm:right-8 sm:bottom-8 sm:h-10 sm:w-10"
        >
          <motion.div
            initial={{ y: 0 }}
            transition={{ duration: 0.2 }}
            className="relative z-10"
          >
            <ChevronUpIcon className="h-4 w-4 sm:h-5 sm:w-5" />
          </motion.div>
        </motion.button>
      )}
    </AnimatePresence>
  )
}
